import { InputHTMLAttributes } from 'react';

interface IProps extends InputHTMLAttributes<any> {
	errorKey: string;
	handleChange: (input: string) => void;
	handleKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	value: string;
	dataComponentType?: string;
	dataComponentKey?: string;
}

const SimpleInput = (props: IProps) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		props.handleChange(e.currentTarget.value);
	};

	return (
		<>
			<input
				data-component-type={props.dataComponentType}
				data-component-key={props.dataComponentKey}
				className="form-control"
				name={props.name}
				onChange={handleChange}
				onKeyDown={props.handleKeyDown}
				type="text"
				value={props.value}
				disabled={props.disabled}
				error-key={props.errorKey}
			/>
		</>
	);
};

export default SimpleInput;
